// Tiny dev overlay: three band bars + beat/onset dots + current section.
// Reads engine.signals each frame. Toggle with D. Pointer-events: none so
// it never blocks the canvas.
const STYLE_ID = 'audio-debug-style';

const STYLE = `
#audio-debug {
  position: fixed; top: 8px; left: 12px; padding: 8px 12px;
  background: rgba(0,0,0,0.6); border-radius: 4px;
  color: #ddd; font: 11px/1.3 monospace; pointer-events: none; z-index: 5;
}
#audio-debug.hidden { display: none; }
#audio-debug .ad-row { display: flex; align-items: center; gap: 6px; margin: 2px 0; }
#audio-debug .ad-label { width: 30px; color: #888; }
#audio-debug .ad-bar { width: 100px; height: 6px; background: #222; border-radius: 2px; overflow: hidden; }
#audio-debug .ad-fill { height: 100%; background: #6af; width: 0%; transition: width 30ms linear; }
#audio-debug .ad-dots { margin-top: 4px; display: flex; gap: 8px; }
#audio-debug .ad-dot { opacity: 0.2; transition: opacity 80ms; }
#audio-debug .ad-dot.flash { opacity: 1; color: #fff; }
#audio-debug .ad-section { margin-top: 4px; color: #888; }
`;

function row(doc, band, label) {
  const r = doc.createElement('div'); r.className = 'ad-row';
  const l = doc.createElement('span'); l.className = 'ad-label'; l.textContent = label;
  const bar = doc.createElement('div'); bar.className = 'ad-bar';
  const fill = doc.createElement('div'); fill.className = 'ad-fill'; fill.dataset.band = band;
  bar.appendChild(fill);
  r.append(l, bar);
  return r;
}

export class AudioDebugOverlay {
  constructor({ engine, mountEl }) {
    this.engine = engine;
    this.mountEl = mountEl;
    this._onKey = this._onKey.bind(this);
    this._beatTimer = null;
    this._onsetTimer = null;
    this.refs = {};
  }

  mount() {
    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = STYLE;
      document.head.appendChild(style);
    }
    while (this.mountEl.firstChild) this.mountEl.removeChild(this.mountEl.firstChild);
    const doc = document;
    const bassRow = row(doc, 'bass', 'bass');
    const midsRow = row(doc, 'mids', 'mids');
    const trebRow = row(doc, 'treble', 'treb');

    const dots = doc.createElement('div'); dots.className = 'ad-dots';
    const beatDot = doc.createElement('span'); beatDot.className = 'ad-dot'; beatDot.dataset.event = 'beat'; beatDot.textContent = '●';
    const onsetDot = doc.createElement('span'); onsetDot.className = 'ad-dot'; onsetDot.dataset.event = 'onset'; onsetDot.textContent = '●';
    dots.append(beatDot, onsetDot);

    const section = doc.createElement('div'); section.className = 'ad-section'; section.textContent = 'silence';

    this.mountEl.append(bassRow, midsRow, trebRow, dots, section);

    this.refs = {
      bass: bassRow.querySelector('.ad-fill'),
      mids: midsRow.querySelector('.ad-fill'),
      treble: trebRow.querySelector('.ad-fill'),
      beatDot, onsetDot, section,
    };

    window.addEventListener('keydown', this._onKey);
  }

  update() {
    const s = this.engine.signals;
    if (!s) return;
    this.refs.bass.style.width = `${(s.bassSpring * 100).toFixed(1)}%`;
    this.refs.mids.style.width = `${(s.midsSpring * 100).toFixed(1)}%`;
    this.refs.treble.style.width = `${(s.trebleSpring * 100).toFixed(1)}%`;
    if (s.beat) {
      this.refs.beatDot.classList.add('flash');
      clearTimeout(this._beatTimer);
      this._beatTimer = setTimeout(() => this.refs.beatDot.classList.remove('flash'), 80);
    }
    if (s.onset) {
      this.refs.onsetDot.classList.add('flash');
      clearTimeout(this._onsetTimer);
      this._onsetTimer = setTimeout(() => this.refs.onsetDot.classList.remove('flash'), 80);
    }
    if (s.section !== this.refs.section.textContent) {
      this.refs.section.textContent = s.section;
    }
  }

  toggle() { this.mountEl.classList.toggle('hidden'); }

  destroy() {
    window.removeEventListener('keydown', this._onKey);
    clearTimeout(this._beatTimer);
    clearTimeout(this._onsetTimer);
    while (this.mountEl.firstChild) this.mountEl.removeChild(this.mountEl.firstChild);
  }

  _onKey(e) {
    if (e.key === 'd' || e.key === 'D') this.toggle();
  }
}
